import mapboxgl from 'mapbox-gl';

var InlineMap = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.data = this.options.$el.find(".map-container").data();

};

InlineMap.prototype.init = function(){

  mapboxgl.accessToken = 'pk.eyJ1IjoiYXV0aGVudGljZmYiLCJhIjoiY2p0M2xhMmRyMHMycTQzcGM4amY3ZW4zOCJ9.gqB1Sg17auDyheEo4QQi5A';

  this.map = new mapboxgl.Map({
    container: this.options.$el.find(".map-container")[0],
    style: 'mapbox://styles/authenticff/cjt3iorem2sc21fo8an3p33v3',
    // style: "mapbox://styles/mapbox/streets-v9",
    center: [this.data.centerLng, this.data.centerLat],
    zoom: this.data.zoom
  });

  if(this.data.marker){
    this.addMarker();
  }

};

/**
 * Adding marker to the map
 * @return {[type]} [description]
 */
InlineMap.prototype.addMarker = function(){

  var $marker = $("<div></div>");

  $marker.css({
    backgroundImage: "url(/built/icons/ring.svg)",
    height: 30,
    width: 30
  });

  new mapboxgl.Marker($marker[0])
  .setLngLat([this.data.markerLng, this.data.markerLat])
  .addTo(this.map);

};

export default  InlineMap;
